import { Option } from '../../../general-types';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { getHumanizeInbodyType } from '../../../shared/utils/inbodyUtils';
import { ScanMetadata } from '../../interfaces/scanMetadata';

export const getInbodyTypeOptions = (
  scansMetadata: ScanMetadata[],
): Option<InbodyType>[] => {
  const inbodyTypes = [...new Set(scansMetadata.map((scan) => scan.inbodyType))];

  return inbodyTypes.map((inbodyType) => ({
    label: getHumanizeInbodyType(inbodyType),
    value: inbodyType,
  }));
};
